import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
import MenuItem from './MenuItem';

// 定义 props

export default {
  __name: 'SidebarItem',
  props: {
    route: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_sidebar_item = _resolveComponent("sidebar-item", true);
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      return __props.route.children.length > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 0,
        index: __props.route.path
      }, {
        title: _withCtx(() => [_createVNode(_unref(MenuItem), {
          title: __props.route.meta.title,
          icon: __props.route.meta.icon
        }, null, 8, ["title", "icon"])]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.route.children, item => {
          return _openBlock(), _createBlock(_component_sidebar_item, {
            key: item.path,
            route: item
          }, null, 8, ["route"]);
        }), 128))]),
        _: 1
      }, 8, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: __props.route.path
      }, {
        default: _withCtx(() => [_createVNode(_unref(MenuItem), {
          title: __props.route.meta.title,
          icon: __props.route.meta.icon
        }, null, 8, ["title", "icon"])]),
        _: 1
      }, 8, ["index"]));
    };
  }
};